import { NavLink, Outlet } from "react-router-dom";
import { SeeAll } from "../Components/SeeAll";

export const P2p = () => {
  const NavLinkStyleBuy = ({ isActive }) => {
    return `text-center py-2 px-6 font-pin rounded text  ${
      isActive ? "bg-green-500 font-semibold text-p-wh" : "normal"
    }`;
  };
  const NavLinkStyleSell = ({ isActive }) => {
    return `text-center py-2 px-6 font-pin rounded text  ${
      isActive ? "bg-red-500 font-semibold text-p-wh" : "normal"
    }`;
  };
  return (
    <div className="flex  flex-col mx-6">
      <div className="flex flex-row justify-between">
        <SeeAll name="" seeAll={false} />

        <nav className="flex flex-row items-center border-[0.4px] rounded">
          <NavLink to="buy" className={NavLinkStyleBuy}>
            Buy Offers
          </NavLink>
          <NavLink to="sell" className={NavLinkStyleSell}>
            Sell Offer
          </NavLink>
        </nav>
      </div>

      <Outlet />
    </div>
  );
};
